import { apiClient } from "services/api/client";
import { IMemberDirectorySummary } from "services/api/types";

export const getMemberDirectorySummary = async () => {
  const url = "sponsors/memberDirectorySummary";

  const response = await apiClient.get<IMemberDirectorySummary>(url);
  return response.data;
};
